import { DayOfWeek } from '@bringg/types';

export enum ViewMode {
	allDays = 'all-days',
	perDay = 'per-day'
}

export interface RowFormValue {
	ratio: number;
	reserved_until_hours: number;
}

export interface ReserveRow extends RowFormValue {
	weekDay?: DayOfWeek;
}

export interface ReserveCapacityFormValues {
	allDaysRows: RowFormValue[];
	perDayRows: RowFormValue[][];
}

export { DayOfWeek } from '@bringg/types';
